import React, { useState, useEffect, useRef } from 'react'
import FsLightbox from 'fslightbox-react';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "@emotion/styled"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BackgroundImage from 'gatsby-background-image'


const ClientSlider = styled.div`
max-width: 100vw;



`
const VideoSlider = styled(Slider)`
.slick-slide{
  padding: 0 10px;
  @media(min-width: 1210px){
  width: 1133px;
  max-width: 100%;
  }
}
.slick-dots{
    z-index: 2;
    position: static;
    background-color: #0e1f38;
    padding-top: 60px;
    margin-top: -10px;

    li button{
      font-size: 0;
    line-height: 0;
    display: block;
    padding: 5px;
    color: transparent;
    border: 0;
    background: 0 0;
    width: 20px;
    height: 20px;
    cursor: pointer;
    }

    @media(min-width: 992px){
      margin-top: -20px;
    }
}
.slick-dots li.slick-active button:before{
  opacity: .75;
    color: #fff;
}
.slick-dots li button:before{
  font-size: 15px;
  color: #fff;
}
.slick-slide img{
  max-width: 100%;
}

@media(min-width: 992px){
  .slick-slide.slick-active.slick-center.slick-current{
    border: 10px solid #B8232D;
    background-color: #B8232D;
  }
  .slick-slide{
    padding: 0;
  }
}
`
const ReviewsSlider = styled(Slider)`
text-align: center;
padding-top: 77px;
background-color: #0e1f38;
position: relative;
color: #fff;

.slick-slide img{
  max-width: 100%;
}
.slick-dots{
  z-index: 2;
  list-style: none;
  list-style-image: none;
  position: static;
  display: block;
  width: 100%;
  padding: 30px 0 40px 0;
  margin: 0;
  text-align: center;
}
.slick-dots li{
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
    display: inline-block;
    margin: 0 5px;
    padding: 0;
}
.slick-dots li button{
  border-radius: 0;
    width: 24px;
    height: 3px;
    background: hsla(0,0%,93.3%,.49) !important;
    padding: 0;
    font-size: 0;
    line-height: 0;
    display: block;
    color: transparent;
    border: 0;
    cursor: pointer;
    text-decoration: none;
    text-transform: none;
    overflow: visible;
    margin: 0;
    font-family: inherit;
}
.slick-dots li button:before{
  opacity: 0;
  font-size: 0;
  line-height: 0;
  width: 0;
  height: 0;
  content: '';
  color: transparent;
}
.slick-dots li.slick-active button{
  background: #b6212a !important;
}
`
const SlideContainer = styled.div`
position: relative;

:hover{
  cursor: pointer;
}
`
const PlayButton = styled(Img)`
position: absolute !important;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);

`
const ClientSay = styled(BackgroundImage)`
background-size: auto;
background-position: 100px 190px;
background-repeat: no-repeat;
min-height: 400px;
padding: 50px 0 0;


::before, ::after{
  background-size: auto;
  background-position: 100px 190px !important;
}

@media(min-width: 768px){
  background-position: right 240px !important;

  ::before, ::after{
  background-position: right 240px !important;
  }
}
@media(min-width: 992px){
  background-position: right top;

  ::before, ::after{
  background-position: right top !important;
  }
}
`
const ProvenSuccessful = styled.p`
text-transform: uppercase;
  letter-spacing: 2px;
    color: #b6212a;
    font-weight: 600;
`
const FiveStarReviewsContainer = styled.div`
display: grid;
grid-template-columns: 25% 75%;
padding-bottom: 60px;
margin-top: 40px;

@media(min-width: 992px){
  padding: 0 30px 90px 30px;
  grid-template-columns: 50% 50%;
  align-items: center;
}
@media(min-width: 1200px){
  grid-template-columns: 60% 40%;
}
`
const FiveStarReviewsColumn1 = styled.div`

`
const FiveStarReviewsBlankMobile = styled.div`
display: none;

@media(min-width: 992px){
  display: block;

  h4{
    margin-bottom: 20px;
    font-size: 54px;
    color: #0b182c;
    padding-right: 40px;
    letter-spacing: 2px;
    font-family: "Playfair Display";
    font-weight: 400;

    @media(min-width: 1057px){
      width: 370px
    }
    @media(min-width: 1246px){
      width: 490px
    }
  }
}
`
const FiveStarReviews= styled.div`
color: #fff;
text-transform: uppercase;
text-align: center;
font-size: 16px;

`
const FiveStarReviewsText = styled.p`
line-height: 30px;

@media(min-width: 768px){
  font-size: 20px;
}
`
const ReviewsIframeContainer = styled.div`
position: relative;
z-index: 1;
[class*="ReviewsContainer"]{
  position: absolute;
  top: 0;
  right: 10px;
  @media(min-width: 992px){
    left: 50%;
    transform: translateX(-50%);
  }
}
`
const RedQuote = styled.span`
color: #b6212a;
    font-size: 48px;
    padding-left: 9px;
    top: 12px;
`
const ClientReview = styled.div`
width: 92%;
font-size: 20px;
    margin: 36px auto;
    line-height: 34px;
    font-family: "Playfair Display";
    font-weight: 400;
    text-align: center;

@media(min-width: 992px){
  width: 52%;
}
`
const ClientName = styled.span`
color: #f1d1a2;
    border-left: 1px solid #b6212a;
    padding-left: 10px;
    text-transform: uppercase;
`
const ClientSliderTextContainer = styled.div`

`
const VideoSliderHeaderSectionMobile = styled.div`
padding-right: 15px;
padding-left: 15px;
margin: 0 auto;

h4{
  margin-bottom: 20px;
  font-size: 30px;
  color: #0b182c;
  padding-right: 40px;
  letter-spacing: 2px;
  font-family: "Playfair Display";
  font-weight: 400;
}

@media(min-width: 992px){
  display: none;
}
`
const DiamondLeft = styled(Img)`
display: none !important;
@media(min-width: 768px){
  display: block !important;
}
`

const WhatOurClientsAreSaying = () =>{

    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();
    const slider1 = useRef(null);
    const slider2 = useRef(null);

    useEffect(() => {
        setNav1(slider1.current);
        setNav2(slider2.current);
      }, []);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
        });
        
        function openLightboxOnSlide(number) {
        setLightboxController({
        toggler: !lightboxController.toggler,
        slide: number
        });
        }

        const settingsTestimonialSlider = {
          dots: true,
          centerMode: true,
          centerPadding: '30px',
          slidesToShow: 1,
          arrows: false,
          variableWidth: true,
          responsive: [
            {
              breakpoint: 1210,
              settings: {
                variableWidth: false
              }
            }
          ]
          
        }
const settingsReviewsSlider = {
  swipeToSlide: true,
  arrows: false,
  dots: true
}
    const data = useStaticQuery(graphql`
    query WhatOurClientsAreSayingQuery {
        client1: file(relativePath: {eq: "client_1.png"}) {
            childImageSharp {
              fluid(maxWidth: 1133, maxHeight: 621, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
          client2: file(relativePath: {eq: "client_2.jpg"}) {
            childImageSharp {
              fluid(maxWidth: 1133, maxHeight: 621, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
          client3: file(relativePath: {eq: "client_3.jpg"}) {
            childImageSharp {
              fluid(maxWidth: 1133, maxHeight: 621, quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
          sliderPlayButton: file(relativePath: {eq: "slider-play-button.png"}) {
            childImageSharp {
              fixed(width: 102, height: 102) {
                  ...GatsbyImageSharpFixed_withWebp_noBase64
              }
            }
          }
          diamondLeft: file(relativePath: {eq: "diamond-left.png"}) {
            childImageSharp {
              fluid(maxWidth: 690, maxHeight: 19, cropFocus: WEST) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
          stars: file(relativePath: {eq: "stars.png"}) {
            childImageSharp {
              fixed(width: 160, height: 27) {
                  ...GatsbyImageSharpFixed_withWebp_noBase64
              }
            }
          }
          clientSayBackground: file(relativePath: { eq: "reviews-section-red-background.png" }) {
            childImageSharp {
              fluid(maxWidth: 1000, quality: 100) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
    }
  `)
    return(
        <>
<ClientSay fluid={data.clientSayBackground.childImageSharp.fluid} loading="lazy">
  <VideoSliderHeaderSectionMobile>
  <h4>
    What Our Clients<br /> Are Saying
    </h4>
    <ProvenSuccessful>
      Proven Successful Results
    </ProvenSuccessful>
    <DiamondLeft imgStyle={{objectPosition: '0 0'}} fluid={data.diamondLeft.childImageSharp.fluid} loading="lazy"/>
    </VideoSliderHeaderSectionMobile>
    <FiveStarReviewsContainer>
    <FiveStarReviewsColumn1>
      <FiveStarReviewsBlankMobile>
    <h4>
    What Our Clients<br /> Are Saying
    </h4>
    <ProvenSuccessful>
      Proven Successful Results
    </ProvenSuccessful>
    <DiamondLeft imgStyle={{objectPosition: '0 0'}} fluid={data.diamondLeft.childImageSharp.fluid} loading="lazy"/>
    </FiveStarReviewsBlankMobile>
    </FiveStarReviewsColumn1>
    <FiveStarReviews>
      <FiveStarReviewsText>
      Trust Our <br /> Five Star Reviews!
      </FiveStarReviewsText>
      
    </FiveStarReviews>
    </FiveStarReviewsContainer>
<ClientSlider>
    <VideoSlider
    asNavFor={nav2} 
    ref={slider1} 
      {...settingsTestimonialSlider}
    >
      
                <SlideContainer onClick={() => openLightboxOnSlide(1)} >
                  <Img fluid={data.client1.childImageSharp.fluid} loading="lazy"/>
                  <PlayButton fixed={data.sliderPlayButton.childImageSharp.fixed} loading="lazy" />
                  
                </SlideContainer>
                <SlideContainer onClick={() => openLightboxOnSlide(2)} >
                  <Img fluid={data.client2.childImageSharp.fluid} loading="lazy"/>
                  <PlayButton fixed={data.sliderPlayButton.childImageSharp.fixed} loading="lazy" />
                </SlideContainer>
                <SlideContainer onClick={() => openLightboxOnSlide(3)} >
                  <Img fluid={data.client3.childImageSharp.fluid} loading="lazy"/>
                  <PlayButton fixed={data.sliderPlayButton.childImageSharp.fixed} loading="lazy" />
                </SlideContainer>

                </VideoSlider>
                <ReviewsSlider
        asNavFor={nav1}
        ref={slider2}
        {...settingsReviewsSlider}
      >
        <ClientSliderTextContainer>
          <Img fixed={data.stars.childImageSharp.fixed} loading="lazy"/>
          <ClientReview>
            <RedQuote>"</RedQuote> Thank you folks so very much! You service was exceptional and you treated me with such calmness and grace. Your entire office staff is warm and professional. I will always recommend your firm to anyone I know in need.
          </ClientReview>
          <ClientName>
            Karleh W.
          </ClientName>
        </ClientSliderTextContainer>
        <ClientSliderTextContainer>
        <Img fixed={data.stars.childImageSharp.fixed} loading="lazy"/>
          <ClientReview>
            <RedQuote>"</RedQuote>  I would like to take this time to say thank you for helping me win my case. I feel vindicated. I especially appreciate the timeliness of issues resolved and the promptness of feedback. Your assistance has been invaluable to me. I will continue to refer my family and friends to the firm.
          </ClientReview>
          <ClientName>
            John F.
          </ClientName>
        </ClientSliderTextContainer>
        <ClientSliderTextContainer>
        <Img fixed={data.stars.childImageSharp.fixed} loading="lazy"/>
          <ClientReview>
            <RedQuote>"</RedQuote>  After I was injured in a motor vehicle accident, I didn’t know where to turn. I was lucky enough to contact your firm. I was extremely happy with the advice and guidance you provided throughout the entire experience, and the settlement you obtained was better than I ever expected.
          </ClientReview>
          <ClientName>
            Courtney J.
          </ClientName>
        </ClientSliderTextContainer>
      </ReviewsSlider>
              </ClientSlider>
              </ClientSay>
              <FsLightbox
              toggler={lightboxController.toggler}
              sources={[
                <iframe src="https://player.vimeo.com/video/368107310" width="1920" height="1080" frameborder="0" allow="fullscreen" allowFullScreen></iframe>,
                <iframe src="https://player.vimeo.com/video/368106841" width="1920" height="1080" frameborder="0" allow="fullscreen" allowFullScreen></iframe>,
                <iframe src="https://player.vimeo.com/video/368106418" width="1920" height="1080" frameborder="0" allow="fullscreen" allowFullScreen></iframe>
              ]}
              slide={lightboxController.slide}
              />
              </>
    )
}
export default WhatOurClientsAreSaying